import { api } from './api';

export const videosApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getVideosList: builder.query({
      query: (params = {}) => {
        const { page = 1, limit = 10, search, sortBy, sortOrder, status, publishStatus: _publishStatus, ...rest } = params;
        const queryParams = {
          page,
          limit,
          ...(search && { search }),
          ...(sortBy && { sortBy }),
          ...(sortOrder && { sortOrder }),
          // Always send status so cache key changes when filter changes (empty = "all")
          status: status !== undefined && status !== null && status !== '' ? String(status) : '',
          ...(rest.is_live === true && { is_live: 'true' }),
          ...(rest.is_live === false && { is_live: 'false' }),
          ...(rest.awaiting_publish === true && { awaiting_publish: 'true' }),
          ...(rest.author_id != null &&
            rest.author_id !== '' && { author_id: rest.author_id }),
          ...(rest.request_id && { request_id: rest.request_id }),
          ...(rest.needs_metadata === true && { needs_metadata: 'true' }),
          ...(rest.startDate && { startDate: rest.startDate }),
          ...(rest.endDate && { endDate: rest.endDate }),
        };
        return { url: '/admin/videos', params: queryParams };
      },
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: 'Video', id })),
              { type: 'Video', id: 'LIST' },
            ]
          : [{ type: 'Video', id: 'LIST' }],
    }),
    deleteVideo: builder.mutation({
      query: (id) => ({
        url: `/admin/videos/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'Video', id },
        { type: 'Video', id: 'LIST' },
      ],
    }),
    deleteVideosBulk: builder.mutation({
      query: (ids) => ({
        url: '/admin/videos',
        method: 'DELETE',
        body: { ids },
      }),
      invalidatesTags: [{ type: 'Video', id: 'LIST' }],
    }),
    regenerateVideoMetadata: builder.mutation({
      query: (id) => ({
        url: `/admin/videos/${id}/regenerate-metadata`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'Video', id },
        { type: 'Video', id: 'LIST' },
      ],
    }),
    regenerateVideosMetadataBulk: builder.mutation({
      query: (ids) => ({
        url: '/admin/videos/regenerate-metadata',
        method: 'POST',
        body: { ids },
      }),
      invalidatesTags: [{ type: 'Video', id: 'LIST' }],
    }),
    toggleVideoPublish: builder.mutation({
      query: (id) => ({
        url: `/admin/videos/${id}/toggle-publish`,
        method: 'PATCH',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'Video', id },
        { type: 'Video', id: 'LIST' },
      ],
    }),
    bulkToggleVideoPublish: builder.mutation({
      query: ({ ids, action }) => ({
        url: '/admin/videos/bulk-toggle-publish',
        method: 'POST',
        body: { ids, action },
      }),
      invalidatesTags: [{ type: 'Video', id: 'LIST' }],
    }),
    setFeaturedVideos: builder.mutation({
      query: ({ ids, featured }) => ({
        url: '/admin/videos/set-featured',
        method: 'PATCH',
        body: { ids, featured },
      }),
      invalidatesTags: (result, error, { ids }) => [
        ...(ids || []).map((id) => ({ type: 'Video', id })),
        { type: 'Video', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetVideosListQuery,
  useDeleteVideoMutation,
  useDeleteVideosBulkMutation,
  useSetFeaturedVideosMutation,
  useRegenerateVideoMetadataMutation,
  useRegenerateVideosMetadataBulkMutation,
  useToggleVideoPublishMutation,
  useBulkToggleVideoPublishMutation,
} = videosApi;
